import { Divider } from '@/third-party-templates/EnercityEasyGo/components/Divider/Divider';
import Stack from '@uikit/components/Stack/Stack';
import styles from './PricingBox.module.scss';

export type PricingBoxProps = {
  label: string;
  price: number;
  subLabel?: string;
  subPrice?: number;
  disclaimer?: string;
  oldPrice?: number;
  priceSuffix?: string;
  subPriceSuffix?: string;
};

export const PricingBox = ({
  label,
  price,
  subLabel,
  subPrice,
  disclaimer,
  oldPrice,
  priceSuffix = '€/kWh',
  subPriceSuffix = '€/min',
}: PricingBoxProps) => {
  return (
    <div className={styles.base}>
      <span className={styles.label}>{label}</span>
      {oldPrice && (
        <span className={styles.oldPrice}>
          {oldPrice.toLocaleString('de', { minimumFractionDigits: 2 })}{' '}
          {priceSuffix}
        </span>
      )}
      <span className={styles.price}>
        {price.toLocaleString('de', { minimumFractionDigits: 2 })} {priceSuffix}
        {disclaimer ? '*' : ''}
      </span>
      {subLabel && <Divider variant={'secondary'} />}
      <Stack flexDirection={'row'} justifyContent={'space-between'}>
        <span className={styles.subLabel}>{subLabel}</span>
        {subPrice && (
          <span className={styles.subPrice}>
            {subPrice.toLocaleString('de')} {subPriceSuffix}
          </span>
        )}
      </Stack>
      {disclaimer && <span className={styles.disclaimer}>{disclaimer}</span>}
    </div>
  );
};
